import {LogitelInit} from './base/logitelInit';
import {HeaderHeightCalculator} from '../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/components/headerHeightCalculator';

const viewRoot = document.querySelector('html') as HTMLElement;
new LogitelInit(viewRoot);

// wird z.b. fuer das artikeldetail benoetigt, da hier die tarifliste nachgeladen wird und hier muss LogitelInit vorhanden sein
if (typeof window !== 'undefined') {
    (window as any)['LogitelInit'] = LogitelInit;
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scrollToHashTarget);
} else {
    scrollToHashTarget();
}

function scrollToHashTarget() {
    const hash = window.location.hash;

    if (hash) {
        setTimeout(() => {
            const element = document.querySelector(hash);
            if (!element) {
                return;
            }
            element.scrollIntoView();
            const headerHeightCalculator = new HeaderHeightCalculator();
            window.scroll(0, window.scrollY - headerHeightCalculator.getHeaderHeight());
        }, 100);
    }
}
